module.exports = __webpack_public_path__ + "static/media/GalleryImage02.faead106.jpg";